<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app >
      <v-toolbar-title style="font-size:1rem;width:94%;padding-left:1.2rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">设备列表
          <span v-if="companyInfo.COMPANY_NAME"> - {{companyInfo.COMPANY_NAME}}</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon @click.stop="dialog = !dialog">
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
      <!-- <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list style="padding:0;">
          <v-list-item class="us-list-item" @click="setClassifyState(false)">
            <v-list-item-title class="us-list-item-title-default">
              <span>默认分类</span>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item class="us-list-item" @click="setClassifyState(true)">
            <v-list-item-title class="us-list-item-title-default">
              <span>按主机分类</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content>
      <v-container style="padding-bottom:4.2rem;">
        <!-- <div>{{datet}}</div> -->
        <v-card style="padding-bottom:0.7rem;" flat>
          <v-row style="text-align:center;margin:0;">
            <v-col style="padding:6px;">
              <div @click="changeState(-1)" style="border-radius: 0.2rem;cursor: pointer;" :style="{background:(state === -1?'#E0E0E0':'#f2f2f2')}">
                <div style="font-size:0.9rem;padding:0.7rem 0 0;" :style="{color:(state === -1?'#000':'#000')}">设备总数</div>
                <div style="font-size:2rem;" :style="{color:(state === -1?'#5cbbf6':'#5cbbf6')}">{{stat.total}}</div>
              </div>
            </v-col>
            <v-col style="padding:6px 0;">
              <div @click="changeState(2)" style="border-radius: 0.2rem;cursor: pointer;" :style="{background:(state === 2?'#E0E0E0':'#f2f2f2')}">
                <div style="font-size:0.9rem;padding:0.7rem 0 0;" :style="{color:(state === 2?'#000':'#000')}">正常数</div>
                <div style="font-size:2rem;" :style="{color:(state === 2?'#67C23A':'#67C23A')}">{{stat.online}}</div>
              </div>
            </v-col>
            <v-col style="padding:6px;">
              <div @click="changeState(1)" style="border-radius: 0.2rem;cursor: pointer;" :style="{background:(state === 1?'#E0E0E0':'#f2f2f2')}">
                <div style="font-size:0.9rem;padding:0.7rem 0 0;" :style="{color:(state === 1?'#000':'#000')}">异常数</div>
                <div style="font-size:2rem;" :style="{color:(state === 1?'#F56C6C':'#F56C6C')}">{{stat.offline}}</div>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <div style="margin-top:0.2rem;">
          <v-container v-if="classify" id="dropdown-example-2">
            <v-overflow-btn
              v-model="gwIotId"
              class="my-2"
              :items="dropdown_icon"
              :label="''"
              segmented
              target="#dropdown-example-2"
              @change="changeGw"
            ></v-overflow-btn>
          </v-container>
          <div v-if="loading" style="padding-top:6.5rem;">
            <LoadingText />
          </div>
          <!-- <div v-else v-for="(item,index) in list" :key="index" style="border-bottom:1px solid #eee;" >
            <DeviceCard :dev-info="item" :idx=" index + 1 " flat />
          </div> -->
          <div v-else>
            <!-- <div v-if="!classify">
              <div v-for="(item,index) in list" :key="index"  style="border-bottom:1px solid #eee;" >
                <DeviceCard :dev-info="item" :idx=" index + 1 " flat />
              </div>
              <ListFooter v-if="!loading" :count="list.length" />
            </div>
            <div v-else>
              <div v-for="(item,index) in classifyList" :key="'p'+index" style="border-bottom:1px solid #eee;" >
                <div style="padding: 0.5rem;margin-top: 2rem;">
                  <span class="us_block_title">{{item.dev_name}}</span>
                </div>
                <div v-for="(s_item,s_index) in item.child_node" :key="'s'+s_index" style="border-bottom:1px solid #eee;" >
                  <DeviceCard :dev-info="s_item" :idx=" s_index + 1 " flat />
                </div>
              </div>
              <ListFooter v-if="!loading" :count="classifyList.length" />
            </div> -->
            <div v-if="classify && !gwIotId">
              <div v-for="(item,index) in classifyList" :key="'p'+index" style="border-bottom:1px solid #eee;" >
                <div style="padding: 0.5rem;margin-top: 2rem;">
                  <span class="us_block_title">{{item.dev_name}}</span>
                </div>
                <div v-for="(s_item,s_index) in item.child_node" :key="'s'+s_index" style="border-bottom:1px solid #eee;" >
                  <DeviceCard :dev-info="s_item" :idx=" s_index + 1 " flat />
                </div>
              </div>
              <ListFooter v-if="!loading" :count="classifyList.length" />
            </div>
            <div v-else>
              <div v-for="(item,index) in list" :key="index"  style="border-bottom:1px solid #eee;" >
                <DeviceCard :dev-info="item" :idx=" index + 1 " flat />
              </div>
              <ListFooter v-if="!loading" :count="list.length" />
            </div>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import DeviceCard from './DeviceCard'
import ListFooter from '../../components/ListFooter'
import LoadingText from '../../components/LoadingText'
export default {
  components: {
    DeviceCard,
    ListFooter,
    LoadingText
  },
  props: {
  },
  data() {
    return {
      list: [],
      stat: {
        total: 0,
        online: 0,
        offline: 0
      },
      state: -1,
      loading: true,
      companyInfo: {},
      datet: '',
      classify: false,
      classifyList: [],
      gwIotId: '',
      dropdown_icon: [
        // { text: 'list', callback: () => console.log('list') },
        // { text: 'favorite', callback: () => console.log('favorite') },
        // { text: 'delete', callback: () => console.log('delete') }
      ]
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    var that = this;
    if (that.$route.query.state) {
      that.state = that.$route.query.state
    }
    that.getOptionData()
    that.initData();
  },
  activated() {
    var that = this
    if (that.$route.query.state) {
      that.state = that.$route.query.state
    }
    that.getOptionData()
    that.initData()
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    async getList() {
      var that = this
      that.list = []
      await that.$api.iot.queryDeviceList({ state: that.state, gw_iot_id: that.gwIotId }).then(res => {
        // console.log('queryDeviceList', res);
        if (!res.success) {
          // that.$toast.error('获取设备列表失败')
          console.log('获取设备列表失败', res);
          return
        }
        var data = res.data
        that.list = data
        that.loading = false
      })
    },
    async getHostClassifyList() {
      var that = this
      that.list = []
      await that.$api.iot.queryListByHostClassify({ state: that.state }).then(res => {
        // console.log('queryListByHostClassify', res);
        if (!res.success) {
          // that.$toast.error('获取设备列表失败')
          console.log('获取设备列表失败', res);
          return
        }
        var data = res.data
        that.classifyList = data
        that.loading = false
      })
    },
    async getStatData() {
      var that = this
      await that.$api.iot.statTotal({ gw_iot_id: that.gwIotId }).then(res => {
        if (!res.success) {
          // that.$toast.error('获取设备统计数量失败')
          console.log('获取设备统计数量失败', res);
          return
        }
        var data = res.data
        that.stat = data
      })
    },
    changeState(val) {
      var that = this
      that.state = val
      that.initData()
    },
    async initData() {
      var that = this
      that.datet = that.$moment().format('YYYY-MM-DD HH:mm:ss')
      that.$store.commit('SET_FNAVVAL', 1)
      that.loading = true
      that.companyInfo = that.$AppHelper.getCustomData('company_info');
      await that.getStatData();
      if (that.classify && !that.gwIotId) {
        await that.getHostClassifyList()
      } else {
        await that.getList()
      }

      that.getHostList()
      that.loading = false
    },
    async setClassifyState(v) {
      var that = this
      that.classify = v
      if (that.classify && !that.gwIotId) {
        await that.getHostClassifyList()
      } else {
        await that.getList()
      }

      that.$AppHelper.setOptionData({ classify: v });
    },
    async getHostList() {
      var that = this
      await that.$api.iot.queryHostList({ state: that.state }).then(res => {
        // console.log('queryHostList', res);
        if (!res.success) {
          // that.$toast.error('获取设备列表失败')
          console.log('获取设备列表失败', res);
          return
        }
        var data = res.data

        that.dropdown_icon = []
        that.dropdown_icon.push({
          text: '全部',
          value: '',
          callback: () => {}
        })
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          const thing =
          {
            text: item.DEV_TEXT,
            value: item.IOT_ID,
            callback: () => {}
          }

          that.dropdown_icon.push(thing)
        }
        that.loading = false
      })
    },
    async getGwStatData(gw_iot_id) {
      var that = this
      await that.$api.iot.statTotal({ gw_iot_id: gw_iot_id }).then(res => {
        if (!res.success) {
          // that.$toast.error('获取设备统计数量失败')
          console.log('获取设备统计数量失败', res);
          return
        }
        var data = res.data
        that.stat = data
      })
    },
    changeGw(v) {
      var that = this
      console.log(v)
      // that.gwIotId = v
      // that.getGwStatData(v)
      that.getStatData()
      that.getList()

      that.$AppHelper.setOptionData({ classify: true, iot_id: v });
    },
    getOptionData() {
      var that = this
      var data = that.$AppHelper.getOptionData();
      that.classify = data.classify
      that.gwIotId = data.iot_id
    }
  }
}
</script>

<style scoped>
.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
</style>
